import React, { useState } from 'react'
import { gsColors } from '../../styles/Variables'
import { Text } from '../../styles/Components'
import Input from '../Input'
import Button from '../Button'
import { claimUserCredit } from '../../services/GraphQlClientService'
import { useRouter } from 'next/router'
import { useUserContext } from '../UserContext'

const GiftInput = ({ onSuccess, customPlaceholder, inputWidth, largeButton = true }) => {
  const { user, setUser } = useUserContext()
  const [promoCode, setPromoCode] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [working, setWorking] = useState(false)
  const history = useRouter()

  const submit = () => {
    if (user) {
      setWorking(true)
      claimUserCredit(user.id, promoCode)
        .then(([userCredit]) => {
          setUser({
            ...user,
            userCredits: [...user.userCredits, userCredit]
          })
          setPromoCode('')
          setSuccess(true)
          setError('')
          setWorking(false)
          setTimeout(() => {
            setSuccess(false)

            if (onSuccess) {
              onSuccess()
            }
          }, 1000)
        })
        .catch(e => {
          setWorking(false)
          setPromoCode('')
          setError(e.message)
        })
    } else {
      history.push('/signin')
    }
  }

  const handleChange = ({ target: { value } }) => {
    setPromoCode(value)
    if (!!value.length && error) {
      setError('')
    }
  }

  return (
    <div className="gift-card-input" data-testid="gift-card-input">
      {!user ? (
        <div className='gift-card-unauthenticated'>
          <Button outline path='/signin?onSuccess=/gift-card'>Sign in</Button>
        </div>
      ) : (
        <div>
          <Input
            width={inputWidth ? inputWidth : '411px' }
            placeholder={ customPlaceholder ? customPlaceholder :  "Enter gift code" }
            value={promoCode}
            onChange={handleChange}
            error={error}
          />
          <Button
            outline
            large={largeButton}
            color='#000'
            loadingColor='rgba(0, 0, 0, .3)'
            disabled={!promoCode.length}
            onClick={submit}
            working={working}
          >
            APPLY
          </Button>
        </div>
      )}
      {error && (
        <Text margin='8px 0 0' variant="small" color={gsColors.errorRed}>
          {error}
        </Text>
      )}
      {success && (
        <Text margin="1rem" variant="small" color={gsColors.persianGreen}>
          Credit applied!
        </Text>
      )}
    </div>
  )
}

export default GiftInput
